export default "__VITE_ASSET__D4Bz48LQ__"